import { ChangeEvent, KeyboardEvent } from "react";
import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useFontSize = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    const handleMinusClick = () => {
        dispatch(
            setSettings({
                id: textBox.id,
                fontSize: textBox.fontSize - 1,
            }),
        );
    };
    const handlePlusClick = () => {
        dispatch(
            setSettings({
                id: textBox.id,
                fontSize: textBox.fontSize + 1,
            }),
        );
    };
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(
            setSettings({
                id: textBox.id,
                fontSize: +e.target.value,
            }),
        );
    };
    const handleKeyUp = (e: KeyboardEvent) => {
        const { key } = e;
        if (key === "ArrowUp") handlePlusClick();
        if (key === "ArrowDown") handleMinusClick();
    };
    return {
        handleChange,
        handleMinusClick,
        handlePlusClick,
        handleKeyUp,
    };
};
